<div class="wrapper">
  <app-warning-zone
    [opened]="warningZoneOpened"
    [text]="warningText"
  ></app-warning-zone>
  <kendo-tabstrip
    (tabSelect)="onTabSelect($event)"
    id="tabstrip"
    style="padding-top: 30px"
  >
    <kendo-tabstrip-tab title="To Do" [selected]="true">
      <ng-template kendoTabContent>
        <div class="content">
          <app-todo-list
            id="sg-todo-list"
            *ngIf="isSgProduct"
            (warningZoneEvent)="showWarningZoneEvent($event)"
          ></app-todo-list>
          <app-mf-hk-todo-list
            id="hk-todo-list"
            *ngIf="isHkProduct"
            (warningZoneEvent)="showWarningZoneEvent($event)"
          >
          </app-mf-hk-todo-list>
        </div>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="Policy">
      <ng-template kendoTabContent>
        <div class="content">
          <app-policy-list
            id="sg-policy-list"
            *ngIf="isSgProduct"
            (warningZoneEvent)="showWarningZoneEvent($event)"
          ></app-policy-list>
          <app-mf-hk-policy-list
            id="hk-policy-list"
            *ngIf="isHkProduct"
            (warningZoneEvent)="showWarningZoneEvent($event)"
          >
          </app-mf-hk-policy-list>
        </div>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab
      *ngIf="identityRolesService.isExportReporter"
      title="Export"
    >
      <ng-template kendoTabContent>
        <div class="content">
          <app-export-list
            (warningZoneEvent)="showWarningZoneEvent($event)"
          ></app-export-list>
        </div>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab *ngIf="identityRolesService.isReporter" title="Report">
      <ng-template kendoTabContent>
        <div class="content">
          <div class="content">
            <app-preset-report
              (warningZoneEvent)="showWarningZoneEvent($event)"
            ></app-preset-report>
          </div>
        </div>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="Reports" *ngIf="isHkProduct && identityRolesService.isUnderwriter">
      <ng-template kendoTabContent>
        <div class="content">
          <app-mf-hk-report-list            
            id="hk-report-list"
            (warningZoneEvent)="showWarningZoneEvent($event)"
          >
          </app-mf-hk-report-list>
        </div>
      </ng-template>
    </kendo-tabstrip-tab>
  </kendo-tabstrip>
</div>
